module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.can_edit) ? _c('div', {
    staticClass: "func"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.task_number),
      expression: "task_number",
      modifiers: {
        "trim": true
      }
    }],
    ref: "union-input",
    staticClass: "number-input",
    attrs: {
      "placeholder": "添加已发布的任务编号"
    },
    domProps: {
      "value": (_vm.task_number)
    },
    on: {
      "focus": function($event) {
        _vm.addflag = false
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.task_number = $event.target.value.trim()
      }, function($event) {
        _vm.addflag = false
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addNumber($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn",
    on: {
      "click": _vm.addNumber
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addflag),
      expression: "addflag"
    }],
    staticClass: "func-tip"
  }, [_vm._v(_vm._s(_vm.addTip))])])], 1) : _vm._e(), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "wrap",
    attrs: {
      "speed": 20
    }
  }, _vm._l((_vm.task_union), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "routerlink"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.openPop(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.union_number) + " - " + _vm._s(item.union_task_name) + "\n            ")]), _vm._v(" "), (_vm.can_edit) ? _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.delUnion(item.union_task_id, index)
        }
      }
    }, [_vm._v("删除\n            ")]) : _vm._e()])
  })), _vm._v(" "), _c('z-windowPop', {
    attrs: {
      "show": _vm.pop.show,
      "height": '80%',
      "noBtns": true,
      "title": ("任务编号：" + (_vm.pop.title)),
      "black": true
    },
    on: {
      "cancel": function($event) {
        _vm.pop.show = false
      }
    }
  }, [_c('readDetail', {
    attrs: {
      "taskId": _vm.pop.id,
      "prohibit": true
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0e617ab2!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/task/detailTask/relation-task.vue
// module id = 689
// module chunks = 1